import { Text, Title } from "../units/Text"
import { Divider } from "../units/Divider"
import { SocMetric } from "./Charts"
import { FC } from 'react';
import { AccumulatorChartDataList,AccumulatorChartData, ActivityProps } from "../../interfaces/Accumulator";
import { TemperatureChart, BalanceChart, ActivityChart } from "./Charts";
import { SocChart } from "../Charts/Soc";
import { BoxWrapper, FlexWrapper } from "../Wrappers/Wrappers";
import { AccumulatorDetails } from "../Rest/FetchACB";
import { ChartDataResponse } from "../Rest/FetchACB";
import { DateRangeEnum, DateRangePicker } from "../Pickers/dataRange";
import { DetailText } from "../units/Text";
import { hasPermission } from "../../roles/roles";
import { useSignedInContext } from "../../context/AuthContextProvider";
import { InfoBlock } from "../../pages/ACBView/ACBView";
import { formatDateTime } from "../../helpers/dateFormatter";


const { formatInTimeZone } = require('date-fns-tz');
const noData = "Нет данных"

const notNull = (element: any) => {
    let isNull = element === null
    let isUndefined = element === undefined

    return !isNull && !isUndefined
}


interface WidgetTitleProps {
    label: string;
    icon: JSX.Element;
}


const IconBalance = () => {
    return (
        <div className="icon-wrapper">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1.22351" y="8.45001" width="4.2625" height="8.25" fill="black"/>
                <rect width="17.05" height="0.55" transform="matrix(1 0 0 -1 0.75 6.79999)" fill="black"/>
                <rect x="6.90698" y="4.59998" width="4.73611" height="12.1" fill="black"/>
                <rect x="13.064" y="9" width="4.2625" height="7.7" fill="black"/>
                <path d="M3.22498 2.95001L4.41576 5.01251H2.03419L3.22498 2.95001Z" fill="black"/>
                <path d="M9.27502 3.5L8.08424 1.4375L10.4658 1.4375L9.27502 3.5Z" fill="black"/>
                <path d="M15.325 2.95001L16.5157 5.01251H14.1342L15.325 2.95001Z" fill="black"/>
            </svg>
        </div>
    )
}


const IconTemperature = () => {
    return <div className="icon-wrapper">
        <svg width="20" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.7847 19.2707C6.39471 19.7771 8.65412 17.7904 8.65412 15.2583C8.65412 13.9338 7.99188 12.7262 6.97904 11.986V3.06523C6.97904 1.74074 5.92724 0.649994 4.5638 0.649994C3.23932 0.649994 2.14857 1.74074 2.14857 3.06523V11.986C0.940953 12.882 0.239755 14.4012 0.590354 16.1153C0.901997 17.6735 2.18752 18.959 3.7847 19.2707ZM2.65499 12.7262L3.00559 12.4535V3.10418C3.00559 2.24717 3.70678 1.58492 4.52485 1.58492C5.38187 1.58492 6.08306 2.28612 6.08306 3.10418V12.4535L6.43366 12.7262C7.25173 13.3105 7.71919 14.2844 7.71919 15.2972C7.71919 16.1542 7.36859 16.9723 6.78426 17.5566C6.16097 18.141 5.38187 18.4916 4.52485 18.4916C2.92768 18.4916 1.68111 17.3619 1.40842 15.9595C1.21364 14.6739 1.6811 13.4274 2.65499 12.7262Z" fill="black"/>
            <path d="M4.56379 17.5566C5.18708 17.5566 5.77141 17.3228 6.19992 16.8943C6.62843 16.4658 6.86216 15.8815 6.86216 15.2582C6.86216 13.7 5.53768 13.1936 5.18708 12.8819V6.29846H3.90155V12.8819C3.62887 13.1936 1.91483 13.8169 2.30438 15.7257C2.49916 16.7385 3.39513 17.5566 4.56379 17.5566Z" fill="black"/>
            <path d="M11.9089 3.29904H7.99182V4.19502H11.9089C12.1427 4.19502 12.3374 4.00024 12.3374 3.76651C12.3764 3.49382 12.1816 3.29904 11.9089 3.29904Z" fill="black"/>
            <path d="M11.4804 6.10383C11.4804 5.8701 11.2856 5.67532 11.0519 5.67532H8.03076V6.5713H11.0519C11.2856 6.53234 11.4804 6.33757 11.4804 6.10383Z" fill="black"/>
            <path d="M12.3764 8.44102C12.3764 8.20729 12.1816 8.01251 11.9479 8.01251H8.03076V8.90849H11.9479C12.1816 8.90849 12.3764 8.67475 12.3764 8.44102Z" fill="black"/>
        </svg>
    </div>
}

const IconSocChart = () => {
    return <div className="icon-wrapper">
        <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.1825 9.45922H10.6699V10.6294H15.1825V9.45922Z" fill="black"/>
            <path d="M11.7674 11.9869L9.85645 10.0443L11.7674 8.10178L12.5809 8.92873L11.4834 10.0443L12.5809 11.1599L11.7674 11.9869Z" fill="black"/>
            <path d="M11.3262 14.1089H6.8136V15.2791H11.3262V14.1089Z" fill="black"/>
            <path d="M10.2288 16.6365L9.41528 15.8096L10.5127 14.694L9.41528 13.5784L10.2288 12.7514L12.1397 14.694L10.2288 16.6365Z" fill="black"/>
            <path d="M19.2499 19.25H13.3099V4.24397H14.7028V3.3H18.1448V4.24397H19.2461V19.25H19.2499ZM14.0774 18.4699H18.4825V5.02412H17.3812V4.08014H15.4741V5.02412H14.0812V18.4699H14.0774Z" fill="black"/>
            <path d="M7.20123 4.63404V3.69007H4.53053V4.63404H3.13379V18.8599H8.30635V4.63404H7.20123Z" fill="black"/>
            <path d="M8.69 19.25H2.75V4.24397H4.14291V3.3H7.58488V4.24397H8.68616V19.25H8.69ZM3.51744 18.4699H7.92256V5.02412H6.82128V4.08014H4.91035V5.02412H3.51744V18.4699Z" fill="black"/>
        </svg>
    </div>
}


export const IconLocation = () => {
    return (
        <div className="icon-wrapper">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.245 0.974054L7.24231 0.975585C5.13971 2.14489 3.62889 4.14944 3.08273 6.49429C2.53651 8.83919 3.00596 11.3059 4.37506 13.2856C6.64995 16.5749 9.05504 20.0525 10.0614 21.5076C10.2746 21.816 10.6255 22 11.0002 22C11.3749 22 11.7257 21.8159 11.939 21.5075C12.9453 20.0525 15.3504 16.5748 17.6252 13.2855C18.9943 11.3058 19.4637 8.83914 18.9175 6.49429C18.3713 4.14944 16.8605 2.14495 14.758 0.975638L14.7553 0.974106C12.42 -0.324667 9.58034 -0.32472 7.245 0.974054ZM7.77865 1.93565C9.78209 0.821462 12.2182 0.821462 14.2216 1.9357L14.2243 1.93718C16.0557 2.95569 17.3716 4.70168 17.8473 6.74409C18.3231 8.78649 17.9142 10.935 16.7217 12.6593C14.4469 15.9486 12.0418 19.4263 11.0355 20.8814C11.0275 20.8931 11.0143 20.9 11.0001 20.9C10.986 20.9 10.9728 20.8931 10.9648 20.8814C9.9585 19.4264 7.55341 15.9488 5.27852 12.6594C4.08598 10.9351 3.67715 8.78655 4.15288 6.74409C4.62855 4.70163 5.94459 2.95569 7.77596 1.93718L7.77865 1.93565Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M7.44793 1.47516L7.44538 1.47661C5.45643 2.58745 4.02728 4.49178 3.51064 6.71938C2.99395 8.94703 3.43802 11.2904 4.73312 13.1711C6.88504 16.2959 9.16013 19.5997 10.112 20.982C10.3138 21.275 10.6457 21.4498 11.0001 21.4498C11.3546 21.4498 11.6864 21.275 11.8882 20.982C12.8401 19.5997 15.1152 16.2959 17.2671 13.171C18.5621 11.2903 19.0061 8.94698 18.4895 6.71938C17.9728 4.49178 16.5437 2.5875 14.5548 1.47666L14.5522 1.47521C12.3432 0.241371 9.65704 0.241321 7.44793 1.47516ZM7.95273 2.38867C9.84788 1.33019 12.1523 1.33019 14.0474 2.38872L14.05 2.39012C15.7824 3.35771 17.0272 5.0164 17.4772 6.95669C17.9272 8.89697 17.5405 10.9381 16.4124 12.5762C14.2606 15.701 11.9855 19.0048 11.0335 20.3872C11.026 20.3982 11.0135 20.4048 11.0001 20.4048C10.9867 20.4048 10.9743 20.3982 10.9667 20.3872C10.0148 19.0049 7.73966 15.7011 5.58774 12.5763C4.45966 10.9382 4.07293 8.89703 4.52294 6.95669C4.97291 5.01635 6.21781 3.35771 7.95018 2.39012L7.95273 2.38867Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M11 4.3999C8.57158 4.3999 6.59998 6.3715 6.59998 8.79992C6.59998 11.2283 8.57158 13.1999 11 13.1999C13.4284 13.1999 15.4 11.2283 15.4 8.79992C15.4 6.3715 13.4284 4.3999 11 4.3999ZM11 5.31417C12.9238 5.31417 14.4857 6.87607 14.4857 8.79992C14.4857 10.7238 12.9238 12.2857 11 12.2857C9.07617 12.2857 7.51426 10.7238 7.51426 8.79992C7.51426 6.87607 9.07617 5.31417 11 5.31417Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M11 4.9502C8.87518 4.9502 7.15002 6.67534 7.15002 8.80021C7.15002 10.9251 8.87518 12.6502 11 12.6502C13.1249 12.6502 14.85 10.9251 14.85 8.80021C14.85 6.67534 13.1249 4.9502 11 4.9502ZM11 5.75018C12.6834 5.75018 14.0501 7.11684 14.0501 8.80021C14.0501 10.4836 12.6834 11.8502 11 11.8502C9.31669 11.8502 7.95002 10.4836 7.95002 8.80021C7.95002 7.11684 9.31669 5.75018 11 5.75018Z" fill="black"/>
            </svg>
        </div>
    )

}


const IconActivity = () => {
    return (
        <div className="icon-wrapper">
            <svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M9.72452 0.149902C9.14745 0.149902 8.67305 0.635968 8.67305 1.22695V9.56183C8.67305 10.1515 9.14745 10.6362 9.72452 10.6362C10.3016 10.6362 10.776 10.1515 10.776 9.56183V1.22695C10.7773 0.637294 10.3016 0.151228 9.72452 0.149902ZM4.0526 2.70371C4.01361 2.70371 3.97332 2.70637 3.93303 2.71035C3.69649 2.73824 3.47554 2.84448 3.30658 3.0158C1.66506 4.69311 0.649994 7.01835 0.649994 9.57362C0.649994 14.6838 4.72451 18.8499 9.72433 18.8499C14.7255 18.8499 18.8 14.6838 18.8 9.57362C18.8 7.01849 17.7836 4.69325 16.1421 3.0158C15.734 2.59878 15.0621 2.59878 14.6539 3.0158C14.2458 3.43282 14.2458 4.12073 14.6539 4.53642C15.9173 5.82728 16.6971 7.59886 16.6971 9.57216C16.6971 13.5203 13.5882 16.6971 9.72419 16.6971C5.86022 16.6971 2.754 13.5204 2.754 9.57216C2.754 7.59869 3.5325 5.82561 4.79581 4.53642C5.20393 4.1194 5.20393 3.43149 4.79581 3.0158C4.59826 2.81394 4.32924 2.70371 4.05238 2.70238L4.0526 2.70371Z" fill="black"/>
            </svg>
        </div>
    )
}


const IconHeart = () => {
    return (
        <div className="icon-wrapper">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99998 18.5509L2.50893 10.4393C1.55312 9.40427 1.01526 8.01622 1.01526 6.5205C1.01526 5.02412 1.55249 3.63425 2.50868 2.59967L2.50893 2.59941C4.39957 0.552133 7.40544 0.492119 9.36022 2.40266L9.99997 3.02793L10.6397 2.40267C12.5945 0.492202 15.5995 0.552025 17.4912 2.59955C18.4467 3.63429 18.9847 5.02446 18.9847 6.5205C18.9847 8.01632 18.4479 9.40296 17.491 10.4393C17.491 10.4393 17.491 10.4393 17.491 10.4393L9.99998 18.5509Z" stroke="black" strokeWidth="1.83056"/>
            </svg>
        </div>
    )
}

const IconBattery = () => {
    return (
        <div className="icon-wrapper">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.1 19.8999H1.9C1.66131 19.8999 1.43239 19.8051 1.2636 19.6363C1.09482 19.4675 1 19.2386 1 18.9999V7.2999C1 7.06121 1.09482 6.83229 1.2636 6.66351C1.43239 6.49472 1.66131 6.3999 1.9 6.3999H18.1C18.3387 6.3999 18.5676 6.49472 18.7364 6.66351C18.9052 6.83229 19 7.06121 19 7.2999V18.9999C19 19.2386 18.9052 19.4675 18.7364 19.6363C18.5676 19.8051 18.3387 19.8999 18.1 19.8999ZM2.8 18.0999H17.2V8.1999H2.8V18.0999Z" fill="black"/>
                <path d="M19 8.20029H0.999976C0.761281 8.20029 0.532362 8.10547 0.363579 7.93669C0.194797 7.76791 0.0999756 7.53899 0.0999756 7.30029V3.70029C0.0999756 3.4616 0.194797 3.23268 0.363579 3.0639C0.532362 2.89511 0.761281 2.80029 0.999976 2.80029H19C19.2387 2.80029 19.4676 2.89511 19.6364 3.0639C19.8052 3.23268 19.9 3.4616 19.9 3.70029V7.30029C19.9 7.53899 19.8052 7.76791 19.6364 7.93669C19.4676 8.10547 19.2387 8.20029 19 8.20029ZM1.89998 6.40029H18.1V4.60029H1.89998V6.40029Z" fill="black"/>
                <path d="M6.39993 4.6001H3.69993C3.46123 4.6001 3.23231 4.50528 3.06353 4.33649C2.89475 4.16771 2.79993 3.93879 2.79993 3.7001V1.0001C2.79993 0.761403 2.89475 0.532484 3.06353 0.363701C3.23231 0.194919 3.46123 0.100098 3.69993 0.100098H6.39993C6.63862 0.100098 6.86754 0.194919 7.03632 0.363701C7.20511 0.532484 7.29993 0.761403 7.29993 1.0001V3.7001C7.29993 3.93879 7.20511 4.16771 7.03632 4.33649C6.86754 4.50528 6.63862 4.6001 6.39993 4.6001ZM4.59993 2.8001H5.49993V1.9001H4.59993V2.8001Z" fill="black"/>
                <path d="M16.3 4.6001H13.6C13.3613 4.6001 13.1323 4.50528 12.9636 4.33649C12.7948 4.16771 12.7 3.93879 12.7 3.7001V1.0001C12.7 0.761403 12.7948 0.532484 12.9636 0.363701C13.1323 0.194919 13.3613 0.100098 13.6 0.100098H16.3C16.5386 0.100098 16.7676 0.194919 16.9363 0.363701C17.1051 0.532484 17.2 0.761403 17.2 1.0001V3.7001C17.2 3.93879 17.1051 4.16771 16.9363 4.33649C16.7676 4.50528 16.5386 4.6001 16.3 4.6001ZM14.5 2.8001H15.4V1.9001H14.5V2.8001Z" fill="black"/>
                <path d="M11.8 10.9002L15.4 10.9002C15.6387 10.9002 15.8677 10.995 16.0364 11.1638C16.2052 11.3326 16.3 11.5615 16.3 11.8002C16.3 12.0389 16.2052 12.2678 16.0364 12.4366C15.8677 12.6054 15.6387 12.7002 15.4 12.7002L11.8 12.7002C11.5614 12.7002 11.3324 12.6054 11.1637 12.4366C10.9949 12.2678 10.9 12.0389 10.9 11.8002C10.9 11.5615 10.9949 11.3326 11.1637 11.1638C11.3324 10.995 11.5614 10.9002 11.8 10.9002Z" fill="black"/>
                <path d="M4.59998 10.9002L8.19998 10.9002C8.43867 10.9002 8.66759 10.995 8.83637 11.1638C9.00515 11.3326 9.09998 11.5615 9.09998 11.8002C9.09998 12.0389 9.00515 12.2678 8.83637 12.4366C8.66759 12.6054 8.43867 12.7002 8.19998 12.7002L4.59998 12.7002C4.36128 12.7002 4.13236 12.6054 3.96358 12.4366C3.7948 12.2678 3.69998 12.0389 3.69998 11.8002C3.69998 11.5615 3.7948 11.3326 3.96358 11.1638C4.13236 10.995 4.36128 10.9002 4.59998 10.9002Z" fill="black"/>
                <path d="M13.6 9.1C13.8387 9.1 14.0676 9.19482 14.2364 9.3636C14.4052 9.53239 14.5 9.76131 14.5 10L14.5 13.6C14.5 13.8387 14.4052 14.0676 14.2364 14.2364C14.0676 14.4052 13.8387 14.5 13.6 14.5C13.3613 14.5 13.1324 14.4052 12.9636 14.2364C12.7948 14.0676 12.7 13.8387 12.7 13.6L12.7 10C12.7 9.76131 12.7948 9.53239 12.9636 9.3636C13.1324 9.19482 13.3613 9.1 13.6 9.1Z" fill="black"/>
            </svg>
        </div>
    )
}

const IconEffiecency = () => {
    return (
        <div className="icon-wrapper">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.4449 18.7001H2.73882C2.44432 18.7001 2.19995 18.465 2.19995 18.1681V7.94233C2.19995 7.65158 2.43806 7.41032 2.73882 7.41032H6.41063L8.39066 2.54798C8.82927 1.48396 10.001 0.890084 11.1289 1.16846L11.6113 1.286C12.7893 1.57675 13.5412 2.69026 13.3532 3.87182L12.8645 6.98966C12.8457 7.10101 12.877 7.19999 12.9397 7.27422C13.0149 7.35464 13.1089 7.39795 13.2154 7.39795H18.9111C19.3372 7.39795 19.7382 7.58353 20.0139 7.90521C20.2896 8.22689 20.4024 8.64755 20.3272 9.06821L18.861 17.5185C18.7357 18.199 18.1404 18.6877 17.4449 18.6877V18.7001ZM3.27769 17.6361H6.24772V8.47434H3.27769V17.6361ZM7.31919 17.6361H17.4386C17.6141 17.6361 17.7644 17.5124 17.7958 17.3453L17.9461 16.504H14.5375C14.243 16.504 13.9986 16.2689 13.9986 15.972C13.9986 15.6751 14.2367 15.44 14.5375 15.44H18.1279L18.4098 13.8192H15.1516C14.8571 13.8192 14.6127 13.5841 14.6127 13.2872C14.6127 12.9903 14.8508 12.7552 15.1516 12.7552H18.5978L18.8735 11.1591H15.7656C15.4711 11.1591 15.2267 10.9179 15.2267 10.6271C15.2267 10.3364 15.4649 10.0951 15.7656 10.0951H19.0552L19.262 8.895C19.2808 8.78365 19.2557 8.67849 19.1868 8.60425C19.1179 8.51764 19.0176 8.47434 18.9111 8.47434H13.2154C12.7956 8.47434 12.4008 8.29494 12.1251 7.97945C11.8494 7.65777 11.7366 7.24329 11.8056 6.835L12.2943 3.71717C12.3946 3.07381 11.9935 2.47993 11.3544 2.31909L10.8657 2.20155C10.2579 2.05309 9.62504 2.36858 9.38693 2.9439L7.31292 8.04131V17.6299L7.31919 17.6361Z" fill="black"/>
            </svg>
        </div>
    )
}

const IconCycles = () => {
    return (
        <div className="icon-wrapper">
            <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position:"relative", left:"-1px"}}>
                <path fillRule="evenodd" clipRule="evenodd" d="M13.2708 16.8965C17.4799 15.9247 20.1042 11.7249 19.1325 7.51583C18.1608 3.30677 13.9609 0.6824 9.75185 1.65414C7.09012 2.26865 4.98284 4.2033 4.11088 6.73972C3.99853 7.06653 3.64253 7.24038 3.31572 7.12803C2.98891 7.01569 2.81505 6.65968 2.9274 6.33287C3.93829 3.39229 6.38349 1.1474 9.47033 0.43475C14.3528 -0.692466 19.2247 2.3518 20.3519 7.23431C21.4791 12.1168 18.4348 16.9887 13.5523 18.1159C8.78601 19.2163 4.0096 16.339 2.74812 11.6267C2.65876 11.2929 2.85693 10.9498 3.19076 10.8605C3.52459 10.7711 3.86765 10.9693 3.95702 11.3031C5.04427 15.3645 9.16204 17.8451 13.2708 16.8965Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M13.0414 16.4344C16.93 15.5215 19.3546 11.5762 18.4568 7.62226C17.5591 3.66829 13.6789 1.20298 9.79035 2.11582C7.33127 2.69309 5.38443 4.51049 4.57886 6.89319C4.47506 7.20019 4.14616 7.36351 3.84423 7.25797C3.54231 7.15243 3.38169 6.818 3.48548 6.511C4.41941 3.74863 6.67844 1.6398 9.53026 0.970339C14.041 -0.0885603 18.542 2.7712 19.5834 7.3578C20.6247 11.9444 17.8123 16.521 13.3015 17.5799C8.89805 18.6136 4.48529 15.9107 3.31986 11.484C3.23729 11.1704 3.42038 10.8482 3.72879 10.7642C4.0372 10.6803 4.35415 10.8664 4.43671 11.18C5.44119 14.9953 9.24544 17.3255 13.0414 16.4344Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M3.38705 9.62981C2.98037 9.44271 2.4873 9.59706 2.28574 9.97455C2.08417 10.352 2.25045 10.8097 2.65713 10.9968L6.5131 12.7708C6.91977 12.9579 7.41285 12.8035 7.61441 12.426C7.81597 12.0485 7.64969 11.5909 7.24301 11.4038L3.38705 9.62981Z" fill="black"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M3.61836 10.7985C3.7598 10.4021 3.5531 9.96606 3.15667 9.82462C2.76025 9.68319 2.32423 9.88989 2.18279 10.2863L0.841742 14.045C0.700305 14.4415 0.90701 14.8775 1.30343 15.0189C1.69985 15.1603 2.13587 14.9536 2.27731 14.5572L3.61836 10.7985Z" fill="black"/>
            </svg>
        </div>
    )
}

export const WidgetTitle: FC<WidgetTitleProps> = ({ label, icon }) => {
    return (
        <div className="flex space-between align-center">
            <div className="flex inner-flex align-center">
                {icon}
                <Text size="lg" className="bold">{label}</Text>
            </div>
            <div>
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.67674 11.6766V6.98486C8.67674 6.54696 8.33268 6.2029 7.89479 6.2029C7.45689 6.2029 7.11283 6.54696 7.11283 6.98486V11.6766C7.11283 12.1145 7.45689 12.4585 7.89479 12.4585C8.33268 12.4585 8.67674 12.1145 8.67674 11.6766ZM7.89479 3.2002C7.28486 3.2002 6.80005 3.68501 6.80005 4.29493C6.80005 4.90486 7.28486 5.38967 7.89479 5.38967C8.50471 5.38967 8.98952 4.90486 8.98952 4.29493C8.98952 3.68501 8.50471 3.2002 7.89479 3.2002Z" fill="#A8A8A8"/>
                    <path d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6568C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 6.94942 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0ZM8 14.4C6.7342 14.4 5.49683 14.0246 4.44435 13.3214C3.39188 12.6182 2.57157 11.6186 2.08717 10.4492C1.60277 9.27972 1.47603 7.9929 1.72298 6.75142C1.96992 5.50994 2.57946 4.36957 3.47452 3.47452C4.36957 2.57946 5.50995 1.96992 6.75142 1.72297C7.9929 1.47603 9.27973 1.60277 10.4492 2.08717C11.6186 2.57157 12.6182 3.39188 13.3214 4.44435C14.0246 5.49682 14.4 6.7342 14.4 8C14.4 9.69738 13.7257 11.3252 12.5255 12.5255C11.3253 13.7257 9.69739 14.4 8 14.4Z" fill="#A8A8A8"/>
                </svg>
            </div>
        </div>
    )
}


const Property = (label: string, value: string, helper?:string) => {
    return (
        <div className="flex" title={ helper ?? helper }>
            <Text className="flex-grow" color="orange">{label}:</Text>
            <Text 
                className="flex-grow text-no-wrap overflow-hidden" 
                style={{maxWidth: '200px', textOverflow:"ellipsis"}}
                
            >{value}</Text>
        </div>
    )
}


const WidgetRatioMetrics = (numeratorLabel:string, denumeratorLabel:string, numerator:number, denumerator:number) => {
    function numberFormatter(value: number):string {
        value = Number((value).toFixed(1))

        if (value >= 1_000_000) {
            return `${Math.floor(value / 1_000_000)}м`
        }
        
        if (value > 100_000 && value < 1_000_000 ) {
            return `${Math.floor(value / 1_000)}т`
        }

        return `${value}`
    }

    return (
        <div className="flex space-between">
            <div className="ratio-metrics">
                <Text color="orange">{numeratorLabel}</Text>
                <Text color="secondary">/ {denumeratorLabel}</Text>
            </div>
            <div className="flex narrow-gap flex-align-bottom">
                <Text size='xxxl' color="orange" className="bold line-fit">{numberFormatter(numerator)}</Text>
                <Text size='xl' color="secondary" className="line-fit"> / {numberFormatter(denumerator)}</Text>            
            </div>
        </div>
    )
}

const WidgetRatioMetricsLabeled = (numeratorLabel:string, denumeratorLabel:string, numerator:number, denumerator:number, label: string) => {
    function numberFormatter(value: number):string {
        value = Number((value).toFixed(1))

        if (value >= 1_000_000) {
            return `${Math.floor(value / 1_000_000)}м`
        }
        
        if (value > 100_000 && value < 1_000_000 ) {
            return `${Math.floor(value / 1_000)}т`
        }

        return `${value}`
    }

    return (
        <div className="flex space-between">
            <div className="ratio-metrics">
                <Text color="orange">{numeratorLabel}</Text>
                <Text color="secondary">/ {denumeratorLabel}</Text>
            </div>
            <div className="flex narrow-gap flex-align-bottom">
                <Text size='xxxl' color="orange" className="bold line-fit">{numberFormatter(numerator)}</Text>
                <Text size='xl' color="secondary" className="line-fit"> / {numberFormatter(denumerator)} {label}</Text>            
            </div>
        </div>
    )
}

const ProgressBar = (progress: number) => {
    return (
        <div className="progress-bar-wrapper">
            <div className="progress-bar-bar" style={{width: `${Math.min(progress, 100)}%`}}></div>
        </div>
    )
}

const ProgressBarDark = (progress: number) => {
    return (
        <div className="progress-bar-wrapper progress-bar-dark">
            <div className="progress-bar-bar" style={{width: `${Math.min(progress, 100)}%`}}></div>
        </div>
    )
}


export const AccumulatorProfileWidget = (accumulator:AccumulatorDetails) => {
    const { user } = useSignedInContext()
    const building = accumulator?.building_id?.building_name 
        ? accumulator.building_id?.building_name 
        : noData
    const customer_comment = accumulator?.customer_comment 
        ? accumulator.customer_comment 
        : noData
    const device_type = accumulator?.client_device_type?.device_name 
        ? accumulator?.client_device_type?.device_name
        : noData
    const title = accumulator?.custom_name
        ? accumulator.custom_name
        : `АКБ ${accumulator.serial_number}` 

    return (
        <BoxWrapper className="flex flex-column space-between show-up acb-profile" bg="bg-primary" p="p2" r="r15">
            <BoxWrapper className="flex space-between align-center" p="p0">
                <BoxWrapper 
                    p="p0" 
                    style={{
                        maxWidth: '400px',
                        textWrap: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    <Text size="xl" className="textOverflow-ellipsis bold">{title}</Text>
                </BoxWrapper>
                { hasPermission({role:user.role, resource:'AcbView', action:'editBtn'}) && 
                    <DetailText href={`/react/acb/${accumulator?.serial_number}/edit`}>
                        <div className="flex narrow-gap">
                            <svg width="16" height="16" id="settings-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 11.6525V8.3475L17.2887 7.81363C17.1405 7.32098 16.9437 6.84602 16.6988 6.39398L18.2117 4.12461L15.8754 1.78828L13.606 3.30117C13.1539 3.05625 12.679 2.85941 12.1863 2.71121L11.6525 0H8.3475L7.81363 2.71125C7.32098 2.85945 6.84602 3.05629 6.39398 3.30121L4.12461 1.78828L1.78828 4.12461L3.30117 6.39398C3.05625 6.84602 2.85941 7.32094 2.71121 7.81363L0 8.34746V11.6525L2.71125 12.1864C2.85945 12.679 3.05629 13.154 3.30121 13.606L1.78828 15.8754L4.12461 18.2117L6.39398 16.6988C6.84602 16.9437 7.32094 17.1406 7.81363 17.2888L8.34746 20H11.6525L12.1864 17.2887C12.679 17.1405 13.154 16.9437 13.606 16.6988L15.8754 18.2117L18.2117 15.8754L16.6988 13.606C16.9437 13.1539 17.1406 12.679 17.2888 12.1863L20 11.6525ZM10 14.1016C7.73863 14.1016 5.89844 12.2614 5.89844 10C5.89844 7.73863 7.73863 5.89844 10 5.89844C12.2614 5.89844 14.1016 7.73863 14.1016 10C14.1016 12.2614 12.2614 14.1016 10 14.1016Z" fill="#BBBABA"/>
                            </svg>
                        </div>
                    </DetailText>
                }
            </BoxWrapper>
            <div className="acb-img-wrapper flex-grow flex align-center justify-center overflow-hidden">
                { accumulator?.image?.image ? (
                    <img src={`${process.env.REACT_APP_DJANGO_SERVER_URL}${accumulator.image.image}`} alt="" />
                ) : (
                    <svg width="230" height="100%" viewBox="0 0 230 231" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M214.215 230.224H58.6533V134.272H70.4738V126.689H98.2846V134.272H174.411V126.689H202.222V134.272H214.215V230.224ZM65.5457 223.103H207.322V141.393H195.33V133.809H181.304V141.393H91.3922V133.809H77.3662V141.393H65.5457V223.103Z" fill="#DDDDDD"/>
                        <path d="M230 216.873H210.046V209.752H223.108V27.532H212.734V17.7766H211.907V27.532H176.653V17.7766H175.86V27.532H165.556V136.586H158.664V20.4113H168.968V10.6559H183.545V20.4113H205.015V10.6559H219.627V20.4113H230V216.873Z" fill="#DDDDDD"/>
                        <path d="M61.3424 216.873H0V15.1065L14.4051 0.224121H126.786L141.191 15.1065V137.37H134.298V18.0616L123.925 7.34486H17.2655L6.8924 18.0616V209.752H61.3424V216.873ZM101.525 37.608C95.5632 37.608 90.7385 32.5879 90.7385 26.4641C90.7385 20.3402 95.5976 15.3201 101.525 15.3201C107.453 15.3201 112.312 20.3402 112.312 26.4641C112.312 32.5879 107.453 37.608 101.525 37.608ZM101.525 22.4052C99.3884 22.4052 97.6309 24.221 97.6309 26.4284C97.6309 28.6359 99.3884 30.4517 101.525 30.4517C103.662 30.4517 105.419 28.6359 105.419 26.4284C105.419 24.221 103.662 22.4052 101.525 22.4052ZM39.7002 37.608C33.7383 37.608 28.9136 32.5879 28.9136 26.4641C28.9136 20.3402 33.7728 15.3201 39.7002 15.3201C45.6277 15.3201 50.4868 20.3402 50.4868 26.4641C50.4868 32.5879 45.6277 37.608 39.7002 37.608ZM39.7002 22.4052C37.5636 22.4052 35.806 24.221 35.806 26.4284C35.806 28.6359 37.5636 30.4517 39.7002 30.4517C41.8369 30.4517 43.5944 28.6359 43.5944 26.4284C43.5944 24.221 41.8369 22.4052 39.7002 22.4052Z" fill="#DDDDDD"/>
                    </svg>
                )}
            </div>
            {Divider()}
            <div className="flex flex-column space-between">
                {Property("Объект" , building)}
                {Property("Техника" , device_type)}
                {Property("Комментарий" , customer_comment, customer_comment)}
            </div>
        </BoxWrapper>
    )
    

}

const getSpecialActivity = (isHeatingActivity: boolean , isCoolingActivity: boolean, is_waterproof_activity: boolean, is_default_activity: boolean) => {
    var res = []
    
    if (isHeatingActivity) {
        res.push("Для морозильника")
    }

    if (isCoolingActivity) {
        res.push("Уличное")
    }
    if (is_waterproof_activity) {
        res.push("IP54")
    }

    if (is_default_activity) {
        res.push("Серийное")
    }
    return res.join(',') || "Отсутствует";
}

export const AccumulatorDetailWidget = (accumulator:AccumulatorDetails | undefined) => {
    const serialNumber = accumulator?.serial_number === undefined ? noData: accumulator.serial_number
    const modelName = accumulator?.model_name 
        ? accumulator.model_name 
        : noData
    const voltage = accumulator?.voltage === null || accumulator?.voltage === undefined ? noData : `${accumulator?.voltage}В`
    const nominal_capacity = accumulator?.nominal_capacity === null || accumulator?.nominal_capacity === undefined ? noData : `${accumulator?.nominal_capacity}Ач`
    const manufacture_date = accumulator?.manufacture_date === null || accumulator?.manufacture_date === undefined ? noData : accumulator?.manufacture_date
    const specialActivity = accumulator === undefined ? noData : getSpecialActivity(accumulator.is_heating_activity, accumulator.is_cooling_activity, accumulator.is_waterproof_activity, accumulator.is_default_activity)

    return (
        <BoxWrapper className="white-box flex flex-column space-between show-up" bg="bg-primary" p="p2" r="r15">
            <WidgetTitle label="Характеристики" icon={IconBattery()}/>
            <div className="flex-grow"></div>

            <div className="flex flex-column flex-grow">

                <div className="flex flex-grow flex-column space-between">
                    {Property("Модель АКБ" ,modelName)}
                    {Property("Серийный номер" ,serialNumber)}
                    {Property("Напряжение" , voltage)}
                    {Property("Номинальная емкость" , nominal_capacity)}
                </div>

                {Divider()}

                <div className="flex flex-column space-between white-box-footer">
                    {Property("Дата производства" ,manufacture_date)}
                    {Property("Исполнение" ,specialActivity)}
                </div>

            </div>
        </BoxWrapper>
    )

    
}


export const SohWidget = (accumulator: AccumulatorDetails, setInfoBlock: (value: InfoBlock) => void) => {
    function sohBackground(errors:number, warnings: number): "bg-danger" | 'bg-warning' | 'bg-success' {
        if (errors > 0) { return 'bg-danger' }
        if (warnings > 0) { return 'bg-warning' }
        return "bg-success"
    }

    function sohStatusText(errors:number, warnings: number):string {
        if (errors > 0) { return 'Батарея неисправнна. Срочно обратитесь в сервисный центр' }
        if (warnings > 0) { return 'Есть предупрежедния. Обратитесь в сервисный центр' }
        return "Батарея в порядке"
    }

    const getCountForType = (typeMessage: number, statusCounts:any): number => {
        const status = statusCounts.find((status:any) => status.TypeMessage === typeMessage);
        return status ? status.count : 0;
    };

    const online_date = accumulator?.online_date ? formatDateTime(accumulator?.online_date) : noData
    const SOH = notNull(accumulator?.soh) ? accumulator?.soh : 0
    const errors = getCountForType(0, accumulator.status_counts)
    const warnings = getCountForType(1, accumulator.status_counts)

    return (
        <BoxWrapper className={`flex flex-column show-up`} r="r15" p="p2" bg={sohBackground(errors, warnings)}>
            <WidgetTitle label="Здоровье АКБ (SOH)" icon={IconHeart()}/>
            {/* <div className="flex-grow"></div> */}
            <div className="flex flex-column flex-grow">
                <div className="flex flex-grow flex-column">        
                    <div className="flex flex-column space-between">
                        <div className="flex space-between align-center">
                            <Text size="xxxxl" color="light" className="bold">{SOH}%</Text>
                            <div>
                                <Text size="sm">Время онлайн:</Text>
                                <Text size="sm" className="bold">{online_date}</Text>
                            </div>
                        </div>
                    </div>
                    {ProgressBar(SOH!)}

                    <Text size="sm">{sohStatusText(errors, warnings)}</Text>
                </div>

                {Divider()}

                <div className="flex space-between">
                    <div className="flex flex-grow narrow-gap">
                        <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.849976 0.200382L0.85009 18.35L15.6998 18.3502L15.7 0.200195L0.849976 0.200382ZM2.65522 2.04193L13.8945 2.04207L13.8945 16.5086L2.65551 16.508L2.65522 2.04193Z" fill="black"/>
                            <path d="M4.70115 8.35455L4.70096 10.1963L11.9785 10.1957L11.978 8.35437L4.70115 8.35455Z" fill="black"/>
                            <path d="M4.70145 3.52705L4.70126 5.3688L11.9781 5.36862L11.9783 3.52687L4.70145 3.52705Z" fill="black"/>
                            <path d="M4.70213 13.1812L4.70171 15.0229L11.9786 15.0227L11.9781 13.1814L4.70213 13.1812Z" fill="black"/>
                        </svg>
                        <Text className="under-line-div fit underline pointer"
                            onClick={(e:any) => {setInfoBlock(InfoBlock.Journal)}}
                        >Журнал</Text>
                    </div>
                    <div className="flex flex-column space-between">
                        <div className="flex flex-grow narrow-gap">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.18188 12.0296H9.81754V13.4127H8.18188V12.0296ZM8.20103 5.79866V7.66943L8.71637 11.5302H9.2822L9.79754 7.66943V5.79866H8.20103ZM9.00014 0.350987C8.79993 0.350987 8.61537 0.463128 8.51964 0.642896L0.973332 14.7512C0.872355 14.939 0.875836 15.1677 0.982907 15.3519C1.08998 15.5371 1.28411 15.6501 1.49477 15.6501H16.5056C16.7154 15.6501 16.9104 15.5371 17.0175 15.3519C17.1237 15.1677 17.128 14.939 17.027 14.7512L9.48072 0.642896C9.38497 0.463116 9.20035 0.350987 9.00014 0.350987ZM9.00014 3.33248C9.1342 3.33248 9.25693 3.40635 9.32049 3.5265L14.6671 13.523H14.6679C14.735 13.6485 14.7323 13.8007 14.661 13.9235C14.5896 14.0472 14.4599 14.1219 14.3206 14.1228H3.6805C3.54035 14.1219 3.41066 14.0472 3.33928 13.9235C3.2679 13.8007 3.26529 13.6485 3.33231 13.523L8.67889 3.5265H8.67976C8.74331 3.40635 8.86696 3.33248 9.00014 3.33248Z" fill="black"/>
                            </svg>
                            <div className="flex space-between flex-grow align-center">
                                <Text>Ошибки</Text>
                                <Text>{errors}</Text>
                            </div>
                        </div>
                        <div className="flex flex-grow narrow-gap">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.2349 15.1994C10.2037 15.1972 12.0903 14.4364 13.4813 13.0854C14.8715 11.7336 15.6522 9.9018 15.65 7.99288C15.6484 6.08459 14.8647 4.25446 13.4722 2.90482C12.0789 1.55603 10.1906 0.799036 8.22201 0.799805C6.25325 0.800556 4.36587 1.55981 2.97401 2.90943C1.58149 4.25973 0.799988 6.0907 0.799988 7.99981C0.80386 9.9096 1.58843 11.7405 2.98254 13.0902C4.37584 14.4405 6.26569 15.199 8.2351 15.1998L8.2349 15.1994ZM3.89696 5.27726L5.42736 3.86012L8.23486 6.57882L11.0424 3.86012L12.5635 5.27726L9.70025 7.99961L12.5629 10.722L11.0418 12.1969L8.23506 9.47458L5.42756 12.1962L3.89716 10.7212L6.71397 7.99961L3.89696 5.27726Z" fill="black"/>
                            </svg>
                            <div className="flex space-between under-line-div flex-grow align-center">
                                <Text>Предупреждения</Text>
                                <Text>{warnings}</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BoxWrapper>
    )
}


export const CyclesWidget = (accumulator: AccumulatorDetails) => {
    const numeratorLabel = "Полные"
    const denumeratorLabel = "Частичные"

    const numerator =  accumulator.cycles ? accumulator.cycles : 0
    const denumerator =  accumulator.part_cycles ? accumulator.part_cycles : 0

    const remainingSrc = Math.round(Math.abs(Math.min(((numerator / 3000) - 1) * 100, 0)))
    return (
        <BoxWrapper className="overflow-hidden flex flex-column space-betweeb show-up" bg="bg-primary" p="p2" r="r15">
            <WidgetTitle label="Циклы" icon={IconCycles()}/>
            { WidgetRatioMetrics(numeratorLabel, denumeratorLabel, numerator, denumerator) }
            <div className="flex flex-column flex-grow space-around">
                <Text size="lg">Оставшийся ресурс (%)</Text>
                <div className="cycles-metric">
                    <div className="flex narrow-gap flex-align-bottom">
                        <Text size="xxxxl" color="dark" className="bold line-fit">{remainingSrc}</Text>
                        <Text size='xl' color="secondary" className="line-fit"> / 100</Text>
                    </div>   
                    <br />          
                    { ProgressBarDark(remainingSrc) } 
                </div>
                 
            </div>
        </BoxWrapper>
    )
}

export const EfficiencyWidget = (accumulator: AccumulatorDetails) => {
    const label = "кВтч"
    const numeratorLabel = "Отдано"
    const denumeratorLabel = "Получено"
    const numerator = accumulator.discharge ? accumulator.discharge : 0
    const denumerator = accumulator.charge ? accumulator.charge : 0

    return (
        <BoxWrapper className="overflow-hidden flex flex-column show-up" bg="bg-primary" p="p2" r="r15">
            <WidgetTitle label="Эффективность" icon={IconEffiecency()} />
            { accumulator?.cycles && accumulator.cycles > 50 ? (
                <>
                    { WidgetRatioMetricsLabeled(numeratorLabel, denumeratorLabel, numerator, denumerator, label) }
                    <div className="efficiency-chart-wrapper">
                        { denumerator > 0 ? SocMetric(numerator, denumerator) : (<></>)}
                    </div>
                </> 
            ) : (
                <BoxWrapper className="full-width full-height flex align-center justify-center flex-column">
                    <svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1918_1952)">
                            <path d="M0.732468 57.574H6.58442C6.98571 57.574 7.31688 57.2467 7.31688 56.8415V24.648C7.31688 24.2428 6.98961 23.9155 6.58442 23.9155H0.732468C0.331169 23.9155 0 24.2428 0 24.648V56.8415C0 57.2428 0.327273 57.574 0.732468 57.574ZM1.46494 25.3766H5.85195V56.109H1.46494V25.3766Z" fill="#DDDDDD"/>
                            <path d="M15.3662 57.5739C15.7675 57.5739 16.0986 57.2466 16.0986 56.8414V18.792C16.0986 18.3868 15.7713 18.0596 15.3662 18.0596H9.51421C9.11291 18.0596 8.78174 18.3868 8.78174 18.792V56.8414C8.78174 57.2427 9.10901 57.5739 9.51421 57.5739H15.3662ZM10.2428 19.5245H14.6337V56.1089H10.2428V19.5245Z" fill="#DDDDDD"/>
                            <path d="M24.1481 57.5742C24.5494 57.5742 24.8806 57.247 24.8806 56.8418V12.9405C24.8806 12.5353 24.5533 12.208 24.1481 12.208H18.2962C17.8949 12.208 17.5637 12.5353 17.5637 12.9405V56.8418C17.5637 57.2431 17.891 57.5742 18.2962 57.5742H24.1481ZM19.0248 13.6729H23.4157V56.1132H19.0248V13.669V13.6729Z" fill="#DDDDDD"/>
                            <path d="M32.926 57.574C33.3273 57.574 33.6584 57.2467 33.6584 56.8416V1.23247C33.6584 0.827273 33.3312 0.5 32.926 0.5H27.074C26.6727 0.5 26.3416 0.827273 26.3416 1.23247V56.8416C26.3416 57.2429 26.6688 57.574 27.074 57.574H32.926ZM27.8065 1.96493H32.1974V56.1091H27.8065V1.96493Z" fill="#DDDDDD"/>
                            <path d="M41.7077 57.5741C42.109 57.5741 42.4402 57.2469 42.4402 56.8417V7.08452C42.4402 6.67932 42.1129 6.35205 41.7077 6.35205H35.8558C35.4545 6.35205 35.1233 6.67932 35.1233 7.08452V56.8417C35.1233 57.243 35.4506 57.5741 35.8558 57.5741H41.7077ZM36.5843 7.81699H40.9752V56.1092H36.5843V7.81699Z" fill="#DDDDDD"/>
                            <path d="M50.4897 57.5743C50.891 57.5743 51.2222 57.247 51.2222 56.8418V27.5743C51.2222 27.1691 50.8949 26.8418 50.4897 26.8418H44.6377C44.2364 26.8418 43.9053 27.1691 43.9053 27.5743V56.8418C43.9053 57.2431 44.2325 57.5743 44.6377 57.5743H50.4897ZM45.3663 28.3067H49.7572V56.1132H45.3663V28.3067Z" fill="#DDDDDD"/>
                            <path d="M59.2675 18.0596H53.4156C53.0143 18.0596 52.6831 18.3868 52.6831 18.792V56.8414C52.6831 57.2427 53.0104 57.5739 53.4156 57.5739H59.2675C59.6688 57.5739 60 57.2466 60 56.8414V18.792C60 18.3868 59.6727 18.0596 59.2675 18.0596ZM58.5351 56.1089H54.1441V19.5245H58.5351V56.1089Z" fill="#DDDDDD"/>
                            <path d="M59.2675 59.0352H0.732468C0.331169 59.0352 0 59.3624 0 59.7676C0 60.1728 0.327273 60.5001 0.732468 60.5001H59.2675C59.6688 60.5001 60 60.1728 60 59.7676C60 59.3624 59.6727 59.0352 59.2675 59.0352Z" fill="#DDDDDD"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1918_1952">
                                <rect width="60" height="60" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <Text className="bold">Недостаточно данных</Text>
                </BoxWrapper>
            ) }
        </BoxWrapper>
    )
}


const evaluateActivity = (
    firstRecord: AccumulatorChartData,
    lastRecord: AccumulatorChartData):ActivityProps => {
        let idleSum = (lastRecord.TimeIDEL - firstRecord.TimeIDEL)
        let chargeSum = (lastRecord.TimeCharge - firstRecord.TimeCharge)
        let dischargeSum =  (lastRecord.TimeDischarge - firstRecord.TimeDischarge)
        let total_time = idleSum + chargeSum + dischargeSum

        return {
            idleSum: idleSum,
            chargeSum: chargeSum,
            dischargeSum: dischargeSum,
            totalTime: total_time
        } 
}

export const EmptyWidget = () => {
    return (
        <FlexWrapper alignItems="center" justifyContent="center" flexDirection="column">
            <Text className="bold">Нет данных</Text>
            <svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1918_1952)">
                    <path d="M0.732468 57.574H6.58442C6.98571 57.574 7.31688 57.2467 7.31688 56.8415V24.648C7.31688 24.2428 6.98961 23.9155 6.58442 23.9155H0.732468C0.331169 23.9155 0 24.2428 0 24.648V56.8415C0 57.2428 0.327273 57.574 0.732468 57.574ZM1.46494 25.3766H5.85195V56.109H1.46494V25.3766Z" fill="#DDDDDD"/>
                    <path d="M15.3662 57.5739C15.7675 57.5739 16.0986 57.2466 16.0986 56.8414V18.792C16.0986 18.3868 15.7713 18.0596 15.3662 18.0596H9.51421C9.11291 18.0596 8.78174 18.3868 8.78174 18.792V56.8414C8.78174 57.2427 9.10901 57.5739 9.51421 57.5739H15.3662ZM10.2428 19.5245H14.6337V56.1089H10.2428V19.5245Z" fill="#DDDDDD"/>
                    <path d="M24.1481 57.5742C24.5494 57.5742 24.8806 57.247 24.8806 56.8418V12.9405C24.8806 12.5353 24.5533 12.208 24.1481 12.208H18.2962C17.8949 12.208 17.5637 12.5353 17.5637 12.9405V56.8418C17.5637 57.2431 17.891 57.5742 18.2962 57.5742H24.1481ZM19.0248 13.6729H23.4157V56.1132H19.0248V13.669V13.6729Z" fill="#DDDDDD"/>
                    <path d="M32.926 57.574C33.3273 57.574 33.6584 57.2467 33.6584 56.8416V1.23247C33.6584 0.827273 33.3312 0.5 32.926 0.5H27.074C26.6727 0.5 26.3416 0.827273 26.3416 1.23247V56.8416C26.3416 57.2429 26.6688 57.574 27.074 57.574H32.926ZM27.8065 1.96493H32.1974V56.1091H27.8065V1.96493Z" fill="#DDDDDD"/>
                    <path d="M41.7077 57.5741C42.109 57.5741 42.4402 57.2469 42.4402 56.8417V7.08452C42.4402 6.67932 42.1129 6.35205 41.7077 6.35205H35.8558C35.4545 6.35205 35.1233 6.67932 35.1233 7.08452V56.8417C35.1233 57.243 35.4506 57.5741 35.8558 57.5741H41.7077ZM36.5843 7.81699H40.9752V56.1092H36.5843V7.81699Z" fill="#DDDDDD"/>
                    <path d="M50.4897 57.5743C50.891 57.5743 51.2222 57.247 51.2222 56.8418V27.5743C51.2222 27.1691 50.8949 26.8418 50.4897 26.8418H44.6377C44.2364 26.8418 43.9053 27.1691 43.9053 27.5743V56.8418C43.9053 57.2431 44.2325 57.5743 44.6377 57.5743H50.4897ZM45.3663 28.3067H49.7572V56.1132H45.3663V28.3067Z" fill="#DDDDDD"/>
                    <path d="M59.2675 18.0596H53.4156C53.0143 18.0596 52.6831 18.3868 52.6831 18.792V56.8414C52.6831 57.2427 53.0104 57.5739 53.4156 57.5739H59.2675C59.6688 57.5739 60 57.2466 60 56.8414V18.792C60 18.3868 59.6727 18.0596 59.2675 18.0596ZM58.5351 56.1089H54.1441V19.5245H58.5351V56.1089Z" fill="#DDDDDD"/>
                    <path d="M59.2675 59.0352H0.732468C0.331169 59.0352 0 59.3624 0 59.7676C0 60.1728 0.327273 60.5001 0.732468 60.5001H59.2675C59.6688 60.5001 60 60.1728 60 59.7676C60 59.3624 59.6727 59.0352 59.2675 59.0352Z" fill="#DDDDDD"/>
                </g>
                <defs>
                    <clipPath id="clip0_1918_1952">
                        <rect width="60" height="60" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
        </FlexWrapper>
    )
}


export const StatisticsCharts = (data: ChartDataResponse, dateRangeOpen: boolean, dateRange: DateRangeEnum, setDateRangeOpen:(value:any) => void, setDateRange:(value:any) => void) => {
    const chartData = data?.data
    function EmptyWidgets() {
        return (
            <>
                <BoxWrapper className="white-box show-up-quick" bg="bg-primary" r="r15" p="p2">
                    <WidgetTitle label="Активность батареи" icon={IconActivity()} />
                    <EmptyWidget/>
                </BoxWrapper>
                <BoxWrapper className="white-box charts" bg="bg-primary" r="r15" p="p2">
                    <WidgetTitle label="Анализ активности" icon={IconSocChart()} />
                    <EmptyWidget/>
                </BoxWrapper>
                <BoxWrapper className="white-box" bg="bg-primary" r="r15" p="p2">
                    <WidgetTitle label="Температура АКБ" icon={IconTemperature()} />
                    <EmptyWidget/>
                </BoxWrapper>
                <BoxWrapper className="white-box" bg="bg-primary" r="r15" p="p2">
                    <WidgetTitle label="Активная балансировка" icon={IconBalance()} />
                    <EmptyWidget/>
                </BoxWrapper>
            </>

        )
    }

    function Widgets(chartData: AccumulatorChartDataList) {
        const firstRecord = chartData.first_record
        const lastRecord = chartData.last_record
        const activityStats = evaluateActivity(firstRecord, lastRecord)
    
        const x_labels: string[] = []
    
        for (let item of chartData.x_axis) {
            const formattedDate = formatInTimeZone(new Date(item*1000), 'Europe/Moscow', 'yyyy-MM-dd HH:mm')
            x_labels.push(formattedDate)
        }

        return (
            <>
            <BoxWrapper className="white-box show-up-quick" bg="bg-primary" r="r15" p="p2">
                <WidgetTitle label="Активность батареи" icon={IconActivity()} />
                { ActivityChart(activityStats) }
            </BoxWrapper>
            <BoxWrapper className="white-box charts" bg="bg-primary" r="r15" p="p2">
                <WidgetTitle label="Анализ активности" icon={IconSocChart()} />
                { SocChart(x_labels, chartData) }
            </BoxWrapper>
            <BoxWrapper className="white-box" bg="bg-primary" r="r15" p="p2">
                <WidgetTitle label="Температура АКБ" icon={IconTemperature()} />
                { TemperatureChart(x_labels, chartData) }
            </BoxWrapper>
            <BoxWrapper className="white-box" bg="bg-primary" r="r15" p="p2">
                <WidgetTitle label="Активная балансировка" icon={IconBalance()} />
                { BalanceChart(x_labels, chartData) }
            </BoxWrapper>
            </>
        )
    }
    
    return (
        <BoxWrapper className="flex flex-column charts" r="r0" p="p0">
            <div style={{width: '250px'}}>
                <DateRangePicker
                    isOpen={dateRangeOpen}
                    dateRange={dateRange}
                    setDateRangeOpen={setDateRangeOpen} 
                    setDateRange={setDateRange} />
            </div>
            { chartData === null ? EmptyWidgets() : Widgets(chartData) }
        </BoxWrapper>
    )
}